import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './kyc.css';
import moment from "moment";



const httpClient = axios.create();
class RoDone extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }


    componentDidMount() {
    }
    componentWillUnmount() {
    }



    render() {

        return (

            <div class="mid-contant">
            <div class="container">		
                <div class="row">
                    <div class="col-12">
                        <div class="head1">
                            <h2>Congratulations</h2>
                        </div>
                    </div>
                    
                    <div class="col-12">
                        <div class="registerbox">
                            <div class="row mb-3">
                                <div class="col-12 col-lg-7">
                                    <form action="kyc.html" target="_blank">
                                    <div class="row">								
                                        <div class="col-12">
                                            <div class="successtxt">
                                                <h5><i class="success"></i> Now you are a an authorised Retailer of FinXpay.</h5>
                                                <h6><img src="images/icon.png" alt=""/> RO Code: 1234567890 <i class="copy"></i></h6>
                                            </div>
                                        </div>
                                        
                                        <div class="col-12">								
                                        <div class="service">										
                                            <input class="form-check-input" type="checkbox" checked disabled/>
                                            <h3>ICICI Retailer’s Mobile Application</h3>										
                                            <p>Mobile and DTH Recharge & Electricity, Gas Landline Data Card Bill Payments  AEPS + Biometric Scanner, FMTS / ICICI Money Transfer</p>										
                                            <h5>₹ 3,650 <img src="images/icici.png" alt="ICICI" class="img-fluid"/></h5>
                                        </div>									
                                    </div>
                                        
                                        <div class="col-12">
                                            <button type="submit" class="btn btn-primary" id="">Complete KYC Process</button>
                                        </div>								
                                    </div>
                                    </form>							
                                </div>
                                
                                <div class="col-12 col-lg-5 d-none d-lg-block">
                                    <div class="rightbanner"><img src="images/success-img.png" alt="Oxigen" class="img-fluid"/></div>
                                </div>				
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, phone
});

export default connect(mapStateToProps, null)(RoDone);
